const popupInit = () => {
  const popupToggle = document.querySelectorAll('.popup-toggle');
  popupToggle.forEach((toggle) => {
    toggle.addEventListener('click', handleEvent);
  });
  document.addEventListener('click', (event) => {
    const popup = event.target.closest('.popup');
    if (!popup) return;
    if (!event.target.closest('.popup__content') || event.target.classList.contains('popup__close')) {
      event.preventDefault();
      popupClose(popup);
    }
  });
};

const handleEvent = (event) => {
  event.preventDefault();
  const popup = document.getElementById(event.target.closest('.popup-toggle').dataset.popupId);
  popupOpen(popup)
};

const popupOpen = (popup) => {
  document.body.classList.add('popup-open');
  popup.classList.add('popup--active');
  popup.offsetHeight;
  popup.classList.add('popup--is-visible');
};

export const popupClose = (popup) => {
  document.body.classList.remove('popup-open');
  popup.classList.remove('popup--is-visible');
  const timeout = setTimeout(() => {
    popup.classList.remove('popup--active');
    clearTimeout(timeout);
  }, 250);
}

export default popupInit;
